import { OrganizationEditFormValues } from '../model/interfaces/entities/IOrganizationEditFormValues'
import { OrganizationTypeEnum } from '../model/enums/OrganizationTypeEnum'
import { IFlexiGroupEditFormValues } from '../model/interfaces/entities/IFlexiGroup'

export const initialValues: IFlexiGroupEditFormValues = {
  name: '',
  description: '',
  active: false
}
